import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GroupedClientStatistics, GroupedTalentStatistics, JobStatistics, TotalClients } from "../../Types/Statistics";
import { buildUrl } from "../../Utils/Api";
import { AppSettings } from "../../Utils/Settings";

const base = 'statistics'

export const statisticsApi = createApi({
    reducerPath: 'statisticsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        prepareHeaders: async (headers, {getState}) =>{
            headers.set(
                'Authorization',
                `Bearer ${(localStorage.getItem('token') ?? '')}`
            );
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getTalentStatistics: builder.query<TotalClients, void>({
            query: (body) => ({
                url: buildUrl(base, 'talents'),
                method: 'GET'
            })
        }),
        getTalentStatisticsGrouped: builder.query<GroupedTalentStatistics, void>({
            query: (body) => ({
                url: buildUrl(base, 'talents-grouped'),
                method: 'GET'
            })
        }),
        getClientStatisticsGrouped: builder.query<GroupedClientStatistics, void>({
            query: (body) => ({
                url: buildUrl(base, 'clients-grouped'),
                method: 'GET'
            })
        }),
        getJobStatisticsGrouped: builder.query<JobStatistics, void>({
            query: (body) => ({
                url: buildUrl(base, 'jobs'),
                method: 'GET'
            })
        }),
    }),
});

export const {
    useGetTalentStatisticsQuery,
    useGetTalentStatisticsGroupedQuery,
    useGetClientStatisticsGroupedQuery,
    useGetJobStatisticsGroupedQuery,
} = statisticsApi;
